import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
import { useQuery } from "@vue/apollo-composable";
import { User, NumberStake } from "@/CodegenTypes";
import { formatDollar } from "@/helpers/formatDollar";
import { sumBy } from "lodash";
import { customMoment } from "@/main";
import { queries } from "@/apollo";
import { formatCount } from "@/helpers/formatCount";


export default /*#__PURE__*/_defineComponent({
  __name: 'NumberStakeModal',
  props: {
    value: { type: Boolean },
    startReleaseDate: null,
    userId: null,
    number: null
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
  (e: "input", val: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: boolean;
  startReleaseDate: Date;
  userId: User["userId"];
  number: string;
};





const queryVariables = computed(() => ({
  releaseDate: customMoment(props.startReleaseDate)
    .startOf("day")
    .toDate(),
  appMode: "DD",
  behalfOf: props.userId,
  number: props.number
}));

const { result, loading: apolloLoading } = useQuery<{
  numberStakes: NumberStake[];
}>(
  queries.numberStakes,
  queryVariables,
  {
    enabled: computed(() => !!props.startReleaseDate && !!props.number && !!props.userId),
    fetchPolicy: "cache-and-network",
  }
);

const numberStakes = computed(() => result.value?.numberStakes ?? null);

const summary = computed(() => {
  if (!numberStakes.value) {
    return null;
  }
  return {
    numberCount: numberStakes.value.length,
    in: {
      big: sumBy(numberStakes.value, (stake) => stake.in.big),
      small: sumBy(numberStakes.value, (stake) => stake.in.small),
      amount: sumBy(numberStakes.value, (stake) => stake.in.amount)
    },
    intake: {
      big: sumBy(numberStakes.value, (stake) => stake.intake.big),
      small: sumBy(numberStakes.value, (stake) => stake.intake.small),
      amount: sumBy(numberStakes.value, (stake) => stake.intake.amount)
    },
    toCompany: {
      big: sumBy(numberStakes.value, (stake) => stake.toCompany.big),
      small: sumBy(numberStakes.value, (stake) => stake.toCompany.small),
      amount: sumBy(numberStakes.value, (stake) => stake.toCompany.amount)
    }
  };
});

function toggleModal(val: boolean) {
  emit("input", val);
}

return { __sfc: true,props, emit, queryVariables, result, apolloLoading, numberStakes, summary, toggleModal, formatDollar, formatCount }
}

})